import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button, Container } from "react-bootstrap";
// Componentes
import VistaDatosAmbitos from "../vistas/VistaAmbitos";
import DatosAmbitosForm from "../formularios/FormAmbitos";
// Contexto
import { ModalContext } from "../../../../context/modalContext";
import { AlertBoxContext } from "../../../../context/alertBoxContext";
// jquery
import $ from "jquery";
// Custom spinner
import CustomSpinner from "../../../generic/CustomSpinner";
// Utils
import { ambitos } from "../../../../contexto";

const DesplegableDatosAmbitos = ({ idProvincia, idMision, categoriaMision, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Datos de ambitos de la misión
  const [datosAmbitos, setDatosAmbitos] = useState({});
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  useEffect(() => {
    handleGetDatosAmbitos();
  }, []);

  // Obtiene los datos de ambitos de la obra
  const getDatosAmbitos = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/ambitos`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Edita los datos de ambitos de una misión
  const postDatosAmbitos = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/misiones/${idMision}/ambitos`,
      method: "POST",
      contentType: "application/json; charset=utf-8",

      xhrFields: {
        withCredentials: true,
      },
      data: JSON.stringify(data),
    };
    return $.ajax(settings);
  };

  // Manejador para obtener los datos de la misión de los ambitos
  const handleGetDatosAmbitos = () => {
    setLoading(true);
    getDatosAmbitos()
      .then((response) => {
        setLoading(false);
        setDatosAmbitos(response.items);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos de ambitos
  const handlePostDatosAmbitos = (data) => {
    setLoading(true);
    modalSetShow(false);
    // Hacemos el put para los ambitos
    postDatosAmbitos(data.objAmbitos)
      .then(() => {
        // TODO no volver a pedir los datos sino gestionar el estado sin volver a pedir.
        handleGetDatosAmbitos();
        addAlert("Exito", "Se han editado los ámbitos de la misión correctamente", "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  return (
    <div style={{ position: "relative" }}>
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Ámbitos
            </Accordion.Toggle>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Editar ámbitos de la misión");
                modalSetContent(<DatosAmbitosForm defaultValues={datosAmbitos} submissionHandler={handlePostDatosAmbitos} objAmbitos={ambitos[categoriaMision]} />);
              }}
            >
              Editar
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={"bg-light"}>
              <VistaDatosAmbitos datosAmbitos={datosAmbitos} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default DesplegableDatosAmbitos;
